import { render } from "./MessageHistory.vue?vue&type=template&id=131e38ea&scoped=true"
import script from "./MessageHistory.vue?vue&type=script&lang=js"
export * from "./MessageHistory.vue?vue&type=script&lang=js"

import "./MessageHistory.vue?vue&type=style&index=0&id=131e38ea&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-131e38ea"

export default script